import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

export interface BVPageViewData {
  bvProduct: 'RatingsAndReviews' | 'AskAndAnswer' | 'Curations'
  productId: string
  brand: string
  type: 'Product' | 'Category' | 'Embedded' | 'Submission' | 'Misc'
  categoryId?: string
  rootCategoryId?: string
  numReviews?: number
  numQuestions?: number
  numAnswers?: number
  avgRating?: number
  percentRecommended?: number
}

export interface BVTransactionItem {
  productId: string
  price: string
  quantity: number
}

export interface BVTransactionData {
  orderId: string
  total: string
  currency: string
  tax?: number
  items: BVTransactionItem[]
}

export const getBVScriptUrl = (locale: string = 'en_US'): string => {
  if (!isBazaarvoiceEnabled()) {
    return ''
  }

  const { BV_ENVIRONMENT } = publicRuntimeConfig
  return `https://apps.bazaarvoice.com/deployments/popshelf/main_site/${BV_ENVIRONMENT}/en_US/bv.js`
}

export const fireBVPageViewEvent = (data: BVPageViewData): void => {
  try {
    executeWhenBVReady((BV) => {
      BV.pixel.trackPageView(data)
    })
  } catch (error) {
    console.error('[Bazaarvoice] Error firing PageView event:', error)
  }
}

export const isBazaarvoiceEnabled = (): boolean => {
  const { BV_ENABLED } = publicRuntimeConfig
  return (
    (BV_ENABLED === 'true' || BV_ENABLED === '1')
  )
}

export const executeWhenBVReady = (callback: (BV: any) => void): void => {
  if (!isBazaarvoiceEnabled()) {
    return
  }

  if (typeof window === 'undefined') {
    return
  }

  if (window.BV) {
    callback(window.BV)
  } else {
    const existingCallback = window.bvCallback
    window.bvCallback = (BV: any) => {
      if (existingCallback) {
        existingCallback(BV)
      }
      callback(BV)
    }
  }
}

export const trackBvTransaction = (data: BVTransactionData): void => {
  try {
    executeWhenBVReady((BV) => {
      BV.pixel.trackTransaction(data)
    })
  } catch (error) {
    console.error('[Bazaarvoice] Error firing transaction event:', error)
  }
}
